import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { CustomModal, ModernButton } from "./CustomModal";
const BLOCKED_WAITING_LIST_PLANS = [0, 1, 2, 4, 5];
const CustomSelectWrap = styled.div`
  max-width: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
  align-items: center;
`;
const CustomSelectOption = styled.div`
  height: auto;
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  position: relative;
  padding: 5px 8px;
  font-size: 13px;
  border-radius: 7px;
  margin: 0;

  cursor: ${({
  $isFull,
  $fromRestaurant
}) => $isFull && !$fromRestaurant ? "default" : "pointer"};

  pointer-events: ${({
  $isFull,
  $fromRestaurant
}) => $isFull && !$fromRestaurant ? "none" : "auto"};

  border: 1px solid
    ${({
  $isSelected,
  $isFull,
  $fromRestaurant,
  $widgetDark
}) => {
  if ($isFull && !$fromRestaurant) {
    return "#d94b4b";
  }
  if ($isSelected) {
    return "var(--widget-main-color, #99b0ad)";
  }
  return $widgetDark ? "rgba(246, 241, 232, 0.28)" : "rgba(153, 176, 173, 0.75)";
}};

  background-color: ${({
  $isSelected,
  $isFull,
  $fromRestaurant,
  $widgetDark
}) => {
  if ($isFull && !$fromRestaurant) {
    return "#d94b4b";
  }
  if ($isSelected) {
    return "var(--widget-main-color, #99b0ad)";
  }
  return $widgetDark ? "rgba(255, 255, 255, 0.06)" : "transparent";
}};

  color: ${({
  $isSelected,
  $isFull,
  $fromRestaurant,
  $widgetDark
}) => {
  if ($isFull && !$fromRestaurant) {
    return "#ffffff";
  }
  if ($isSelected) {
    return "#ffffff";
  }
  return $widgetDark ? "#f6f1e8" : "#343a38";
}};

  box-sizing: border-box;

  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    transform 0.15s ease;

  &:hover {
    border-color: ${({
  $isFull,
  $fromRestaurant
}) => $isFull && !$fromRestaurant ? "#d94b4b" : "var(--widget-main-color, #99b0ad)"};

    background-color: ${({
  $isSelected,
  $isFull,
  $fromRestaurant,
  $widgetDark
}) => {
  if ($isFull && !$fromRestaurant) {
    return "#d94b4b";
  }
  if ($isSelected) {
    return "var(--widget-main-color, #99b0ad)";
  }
  return $widgetDark ? "rgba(255, 255, 255, 0.11)" : "rgba(153, 176, 173, 0.1)";
}};

    transform: ${({
  $isFull,
  $fromRestaurant
}) => $isFull && !$fromRestaurant ? "none" : "translateY(-1px)"};
  }
`;
const CustomSelectText = styled.span`
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  line-height: 1.15;
  white-space: nowrap;
`;
const FullText = styled.span`
  color: #ffffff;
  white-space: nowrap;
`;
const PlanLock = styled(FontAwesomeIcon)`
  color: #ee754c;
  font-size: 12px;
  flex: 0 0 auto;
`;
const ModalContent = styled.div`
  padding: 8px 2px;
`;
const ModalText = styled.p`
  margin: 0 0 18px;
  color: #343a38;
`;
const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
`;
const getLabel = item => {
  const itemString = String(item || "");
  if (itemString === "Lunch" || itemString === "Lunch/f") {
    return "Almoço";
  }
  if (itemString === "Dinner" || itemString === "Dinner/f") {
    return "Jantar";
  }
  if (itemString === "Breakfast" || itemString === "Breakfast/f") {
    return "Pequeno Almoço";
  }
  if (itemString === "reservation") {
    return "Reserva";
  }
  if (itemString === "waiting_list") {
    return "Fila à porta";
  }
  if (itemString.endsWith("/f")) {
    return itemString.slice(0, -2);
  }
  return itemString;
};
function CustomSelect({
  items,
  onSelectChange,
  selectedItem,
  getBorderColor,
  setUpdate = null,
  from_restaurant = false,
  widgetDark = false,
  sub_lvl = null,
  restaurant_id = null
}) {
  const {
    t
  } = useTranslation();
  const navigate = useNavigate();
  const [showWaitingListUpgradeModal, setShowWaitingListUpgradeModal] = useState(false);
  const hasSubscriptionLevel = sub_lvl !== null && sub_lvl !== undefined && sub_lvl !== "";
  const isWaitingListBlockedForPlan = hasSubscriptionLevel && BLOCKED_WAITING_LIST_PLANS.includes(Number(sub_lvl));
  const handleItemClick = item => {
    const itemString = String(item || "");
    const isBlockedWaitingList = itemString === "waiting_list" && isWaitingListBlockedForPlan;
    if (isBlockedWaitingList) {
      setShowWaitingListUpgradeModal(true);
      return;
    }
    const nextValue = selectedItem === item ? "" : item;
    onSelectChange(nextValue);
    if (typeof setUpdate === "function") {
      setUpdate(previousValue => typeof previousValue === "number" ? previousValue + 1 : 1);
    }
  };
  const handleViewPlans = () => {
    setShowWaitingListUpgradeModal(false);
    if (restaurant_id !== null && restaurant_id !== undefined) {
      navigate(`/pick_plan_and_pay/${restaurant_id}`);
    }
  };
  return <>
      <CustomSelectWrap>
        {items?.map((item, index) => {
        const itemString = String(item || "");
        const isFull = itemString.endsWith("/f");
        const isWaitingListBlocked = itemString === "waiting_list" && isWaitingListBlockedForPlan;
        const isSelected = !isWaitingListBlocked && selectedItem === item;
        return <CustomSelectOption key={`${itemString}-${index}`} id={`custom-select-option-${index}`} $isSelected={isSelected} $isFull={isFull} $fromRestaurant={from_restaurant} $widgetDark={widgetDark} onClick={() => handleItemClick(item)} aria-haspopup={isWaitingListBlocked ? "dialog" : undefined} title={isWaitingListBlocked ? "Ver planos com acesso à fila à porta" : undefined} style={{
          borderColor: !isWaitingListBlocked && getBorderColor ? getBorderColor(item) : undefined
        }}>
              <CustomSelectText>
                <span>{getLabel(itemString)}</span>

                {isWaitingListBlocked && <PlanLock icon={faLock} />}

                {isFull && !from_restaurant && <FullText>{t("ui.components.selectableCustom.lotado")}</FullText>}
              </CustomSelectText>
            </CustomSelectOption>;
      })}
      </CustomSelectWrap>

      <CustomModal show={showWaitingListUpgradeModal} onHide={() => setShowWaitingListUpgradeModal(false)} title={t("ui.components.selectableCustom.filaAPorta")}>
        <ModalContent>
          <ModalText>{t("ui.components.selectableCustom.aCriacaoDeFilaAPorta")}</ModalText>

          <ModalButtons>
            <ModernButton color="#99b0ad" onClick={() => setShowWaitingListUpgradeModal(false)}>{t("ui.components.selectableCustom.agoraNao")}</ModernButton>

            <ModernButton color="#ee754c" onClick={handleViewPlans} disabled={restaurant_id === null || restaurant_id === undefined}>{t("ui.components.selectableCustom.verPlanos")}</ModernButton>
          </ModalButtons>
        </ModalContent>
      </CustomModal>
    </>;
}
export default CustomSelect;
